import { appURLs } from "@/app/constants.mjs";
import * as AuthActions from "@/feature-auth/utils/auth-actions.mjs";

export function checkForAuthorization(
  errorMessage?: string,
  url?: string,
): boolean {
  if (
    url &&
    !(url.startsWith(appURLs.AUTH) || url.startsWith(appURLs.PAYMENTS))
  ) {
    return false;
  }

  const isUnauthorized =
    errorMessage?.toLowerCase().includes("unauthenticated") ||
    errorMessage?.toLowerCase().includes("not authorized");

  if (isUnauthorized) {
    AuthActions.logoutUser();
    return true;
  }

  return false;
}
